import Modal from 'components/Modal';
import Text from 'components/Text';
import { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import anybody_img from './icons/anybody.png';
import { useAppDispatch } from 'store/hooks';
import { aptUIActions } from 'features/appointment/services/reducers';
const FormStyled = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;
type Props = {
  onConfirm: () => void;
};
type Ref = {
  open: () => void;
};
export const useModalReferAnybodyRef = () => useRef<Ref>(null);
const ModalReferAnybody = forwardRef<Ref, Props>(({ onConfirm }, ref) => {
  const [open, setOpen] = useState(false);
  const dispatch = useAppDispatch();
  const onOpen: Ref['open'] = () => setOpen(true);
  const onClose = () => {
    setOpen(false);
    onConfirm();
    dispatch(aptUIActions.setVisibleAnybodyBooking(false));
  };
  const handleFinish = () => {
    onConfirm();
    onClose();
    dispatch(aptUIActions.setVisibleAnybodyBooking(true));
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  if (!open) return null;

  return (
    <Modal visible={open} onClose={onClose} width={500}
      hiddenHeader
      okTitle='Yes'
      cancelTitle='No'
      onSubmit={handleFinish}
      v2
    >
      <FormStyled>
        <img src={anybody_img} style={{ width: 100, height: 100 }} alt='anybody_img' />
        <Text variant='CONTENT_2' style={{ textAlign: 'center', marginTop: 16, fontSize: 24 }}>Do you refer to everyone available?</Text>
      </FormStyled>
    </Modal>
  );
});
ModalReferAnybody.displayName = 'ModalReferAnybody';
export default ModalReferAnybody;
